import React__default from 'react';
import { SelectionSetTileDescription as SelectionSetTileDescription$1 } from '@vp/swan';
import { OptionMarkdownText } from '../../../shared/option-markdown-text/option-markdown-text.mjs';

const SelectionSetTileDescription = ({ descriptionMarkdown }) => {
    return (React__default.createElement(React__default.Fragment, null, descriptionMarkdown && (React__default.createElement(SelectionSetTileDescription$1, null,
        React__default.createElement(OptionMarkdownText, { markdownText: descriptionMarkdown })))));
};

export { SelectionSetTileDescription };
//# sourceMappingURL=description.mjs.map
